export interface Experiment {
  id: string;
  description: string;
  audiences: Audience[];
  bucket: (userId: string, experimentId: string) => string;
}

export interface Audience {
  id: string;
  description: string;
  isMember: (cstmAttrs: CustomAttributes) => boolean;
}

export interface CustomAttributes {
  experimentToken: string;
  [index: string]: any;
}

export const localStorageExperimentKey = 'active_experiments' as string;
